module.exports = __webpack_public_path__ + "img/Presentation2_old.2e2fe948.png";